// extracted by mini-css-extract-plugin
export default {"collapse":"styles_collapse__cYKRO","collapse-closed":"styles_collapse-closed__d4td5","arrow":"styles_arrow__DBdtu","tariffs":"styles_tariffs__bEjc3"};